import { VoucherCouponService } from 'app/services/voucher-coupon-mg/voucher-coupon.service';
import { KontableNewComponent } from './../../../../modules/UIKit/components/kontablenew/kontablenew.component';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-emission',
  templateUrl: './emission.component.html',
  styleUrls: ['./emission.component.css']
})
export class EmissionComponent implements OnInit {
  @Input() couponVoucherId: string;  

  paginationType = KontableNewComponent.ServerPagination;
  
  show = {
    emission:false    
  }

  initialFilters = new Array<{key: string, value: any}>()

  methodsNames = { list: 'getEmission', sendExtSearchQuery: 'sendExtSearchQuery' }

  constructor(
    private srvVoucherCoupon: VoucherCouponService
  ) { }

  ngOnInit() {
    this.initialFilters.push({key: "voucherId", value: this.couponVoucherId});         
    this.show.emission = true;
  }  
  getDateTime(dateTime:string): string{    
    let res = "";
    if(dateTime && dateTime.length > 0){
      res = dateTime.substr(8,2) + "/" + dateTime.substr(5,2) + "/" + dateTime.substr(0,4) + " " + dateTime.substr(11,8);
    }
    return res;
  }  
}



// WEBPACK FOOTER //
// ./src/app/views/voucher-coupon-mg/voucher-coupon-mg-detail/emission/emission.component.ts